import React from 'react';

import EngageDeck from '../../components/EngageDeck';
import slides from './slides';
import questions from './questions';
import { config } from '../../../../constants/config';

// NobleOak logo (site icon via Google's favicon service); swap for an official logo URL if preferred
const NOBLEOAK_LOGO = 'https://www.google.com/s2/favicons?domain=nobleoak.com.au&sz=128';

/* ======================================================
   /engage/nobleoak/557340
   Private engagement proposal for NobleOak Life Limited.
   Note: the password check runs in the browser, so treat it as a
   courtesy gate rather than real security.
====================================================== */

const NobleOakEngagement = () => (
  <EngageDeck
    title="Optiii × NobleOak — Private presentation"
    preparedFor="NobleOak"
    clientLogo={NOBLEOAK_LOGO}
    password="GrowingNobleOak"
    storageKey="optiii-engage-nobleoak-557340"
    slides={slides}
    questions={questions}
    // Each click is saved here (see engage/README.md for the endpoint)
    saveUrl={config.SERVER_API_URL ? `${config.SERVER_API_URL}/engage/responses` : undefined}
  />
);

export default NobleOakEngagement;
